import { useNavigate } from "react-router-dom";

import { useTranslation } from "@/core/i18n";
import AddedToCartCheck from "atoms/icon/icons/ic_added_to_cart_check_ol.svg";
import { useShopFlowPath } from "modules/standaloneProducts/standaloneProductsPaths";
import { ActionModal } from "molecules/modal-window/action-modal/ActionModal";

import { useIsAnonymousCheckout } from "./anonymousBrowsingState";
import { useHasPurchasableItems } from "./pendingCart";

export type AnonymousAddedVariant = "item" | "offer";

type Props = {
  open: boolean;
  platformId: string;
  variant: AnonymousAddedVariant;
  onClose: () => void;
};

export const AnonymousAddedToCartPrompt = ({ open, platformId, variant, onClose }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const flowPath = useShopFlowPath();
  const anonymousCheckout = useIsAnonymousCheckout();
  const canCheckOut = useHasPurchasableItems(platformId);
  const isOffer = variant === "offer";

  return (
    <ActionModal
      open={open}
      onClose={onClose}
      size="auto"
      headerIconSvg={AddedToCartCheck}
      title={
        isOffer ? t("anonymousBrowsing.offerSavedTitle") : t("anonymousBrowsing.addedToCartTitle")
      }
      description={
        <p className="px-2 pt-4 text-center text-body1 text-secondary">
          {isOffer
            ? anonymousCheckout
              ? t("anonymousBrowsing.offerSavedBodyCheckout")
              : t("anonymousBrowsing.offerSavedBody")
            : anonymousCheckout
              ? t("anonymousBrowsing.addedToCartBodyCheckout")
              : t("anonymousBrowsing.addedToCartBody")}
        </p>
      }
      // `anonymousCheckoutLoader` turns an itemless cart away, so offering checkout here bounces.
      firstButtonLabel={
        anonymousCheckout && canCheckOut
          ? t("anonymousBrowsing.checkout")
          : t("anonymousBrowsing.viewCart")
      }
      onFirstButtonClick={() =>
        navigate(flowPath(anonymousCheckout && canCheckOut ? "/cart/checkout" : "/cart"))
      }
      secondButtonLabel={t("anonymousBrowsing.keepBrowsing")}
      onSecondButtonClick={onClose}
      useAnimatedBackground
    />
  );
};
